<template>
  <el-table-column
    prop="issue_date"
    sortable="custom"
    label="Kiállítás"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.issue_date | date }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'issue_date',
};
</script>
